import React from "react";
import { motion } from "framer-motion";
import "./Vision.css";
import icon1 from "../assets/icon1.png";
import icon1a from "../assets/icon1a.png";
import icon2 from "../assets/icon2.png";
import icon2a from "../assets/icon2a.png";

import icon3 from "../assets/icon3.png";
import icon3a from "../assets/icon3a.png";

import icon4 from "../assets/icon4.png";
import icon4a from "../assets/icon4a.png";

import icon5 from "../assets/icon5.png";
import icon5a from "../assets/icon5a.png";

import icon6 from "../assets/icon6.png";
import icon6a from "../assets/icon6a.png";

import icon7 from "../assets/icon7.png";
import icon7a from "../assets/icon7a.png";

import Footer from "./Footer";

const Vision = () => {
  return (
    <section id="vision">

      <div className="mission-vision-container">

        {/*PAGE TITLE*/}

        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Vision & Mission
        </motion.h2>

        <motion.div
          className="mission-underline"
          initial={{ width: 0 }}
          whileInView={{ width: "330px" }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        />

        {/*  MISSION & VISION SECTION*/}

        <motion.div
          className="mission-section"
          initial={{ opacity: 0, x: -100 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >

      

          {/* Mission Content */}

          <motion.div
            className="mission-content"
            initial={{ opacity: 0, x: 100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
            viewport={{ once: true }}
          >

            {/* VISION*/}

            <motion.div
              className="vision-box"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.3 }}
              viewport={{ once: true }}
            >

              <div className="icon-title">

                <div className="icon-wrapper">

                  <img
                    className="value-icon normal"
                    src={icon2}
                    alt="Vision icon"
                  />

                  <img
                    className="value-icon hover"
                    src={icon2a}
                    alt="Vision hover icon"
                  />

                </div>

                <h3>Vision</h3>

              </div>

              <p>
                To accelerate adoption of sustainable light alloy
                solutions, globally.
              </p>

            </motion.div>

            {/* MISSION*/}

            <motion.div
              className="mission-box"
              initial={{ opacity: 0, y: 80 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
            >

              <div className="icon-title">

                <div className="icon-wrapper">

                  <img
                    className="value-icon normal"
                    src={icon1}
                    alt="Mission icon"
                  />

                  <img
                    className="value-icon hover"
                    src={icon1a}
                    alt="Mission hover icon"
                  />

                </div>

                <h3>Mission</h3>

              </div>

              {/* Mission Content */}

              <ul>

         

                <li className="mission-intro">
                  To be the supplier of{" "}
                  <strong>first choice</strong>{" "}
                  for global customers in the chosen segments by:
                </li>

                {/* Mission Point 1 */}

                <li>
                  Achieving the{" "}
                  <strong>
                    best customer satisfaction
                  </strong>{" "}
                  by offering products of the highest quality
                  at a{" "}
                  <strong>
                    competitive cost in order to achieve profitable growth
                  </strong>.
                </li>

                {/* Mission Point 2 */}

                <li>
                  Co-creating{" "}
                  <strong>
                    innovative solutions for light-weighting vehicles
                  </strong>{" "}
                  using deep understanding of science.
                </li>

                {/* Mission Point 3 */}

                <li>
                  Leveraging{" "}
                  <strong>
                    digitalization
                  </strong>{" "}
                  of{" "}
                  <strong>
                    operations & business processes
                  </strong>{" "}
                  to enhance data-driven decision-making.
                </li>

                {/* Mission Point 4 */}

                <li>
                  We shall do this by adopting{" "}
                  <strong>
                    TQM
                  </strong>{" "}
                  as the{" "}
                  <strong>
                    way of life
                  </strong>.
                </li>

              </ul>

            </motion.div>

          </motion.div>

        </motion.div>

        {/*  CORE VALUES TITLE*/}

        <motion.h2
          className="section-title"
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          Core Values
        </motion.h2>

        <motion.div
          className="mission-underline"
          initial={{ width: 0 }}
          whileInView={{ width: "260px" }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        />

        {/*  CORE VALUES GRID */}

        <motion.div
          className="core-values-grid"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1 }}
          viewport={{ once: true }}
        >

          {/* TRUST*/}

          <motion.div
            className="value-card"
            whileHover={{ scale: 1.05 }}
            transition={{
              type: "spring",
              stiffness: 200
            }}
          >

            <div className="icon-wrapper">

              <img
                className="value-icon normal"
                src={icon3}
                alt="Trust icon"
              />

              <img
                className="value-icon hover"
                src={icon3a}
                alt="Trust hover icon"
              />

            </div>

            <h4>Trust</h4>

            <p>
              To demonstrate transparency & fairness in all dealings;
              honor all commitments diligently.
            </p>

          </motion.div>

         
          <motion.div
            className="value-card"
            whileHover={{ scale: 1.05 }}
            transition={{
              type: "spring",
              stiffness: 200
            }}
          >

            <div className="icon-wrapper">

              <img
                className="value-icon normal"
                src={icon4}
                alt="Value icon"
              />

              <img
                className="value-icon hover"
                src={icon4a}
                alt="Value hover icon"
              />

            </div>

            <h4>Value</h4>

            <p>
              To live by SCL values and add value to the company
              and its stakeholders in every action and focus on
              simplification.
            </p>

          </motion.div>

          {/*EXACTNESS*/}

          <motion.div
            className="value-card"
            whileHover={{ scale: 1.05 }}
            transition={{
              type: "spring",
              stiffness: 200
            }}
          >

            <div className="icon-wrapper">

              <img
                className="value-icon normal"
                src={icon5}
                alt="Exactness icon"
              />

              <img
                className="value-icon hover"
                src={icon5a}
                alt="Exactness hover icon"
              />

            </div>

            <h4>Exactness</h4>

            <p>
              Communicate and act with clarity and precision based
              on following process and fact-based analysis.
            </p>

          </motion.div>

          {/* SPEED AGILITY */}

          <motion.div
            className="value-card"
            whileHover={{ scale: 1.05 }}
            transition={{
              type: "spring",
              stiffness: 200
            }}
          >

            <div className="icon-wrapper">

              <img
                className="value-icon normal"
                src={icon6}
                alt="Speed Agility icon"
              />

              <img
                className="value-icon hover"
                src={icon6a}
                alt="Speed Agility hover icon"
              />

            </div>

            <h4>Speed Agility</h4>

            <p>
              Be agile, proactively adapting to the changing
              environment by moving to move fast, with rigor.
            </p>

          </motion.div>
           <motion.div
            className="value-card"
            whileHover={{ scale: 1.05 }}
            transition={{
              type: "spring",
              stiffness: 200
            }}
          >

            <div className="icon-wrapper">

              <img
                className="value-icon normal"
                src={icon7}
                alt="Customer Centricity icon"
              />

              <img
                className="value-icon hover"
                src={icon7a}
                alt="Customer Centricity hover icon"
              />

            </div>

            <h4>Customer Centricity</h4>

            <p>
              A strong mindset to delight customers through proactively
              understanding their needs with deep insights and
              collaborating for customer's success.
            </p>

          </motion.div>

        </motion.div>

     

       

      </div>

     

      <Footer />

    </section>
  );
};

export default Vision;